import './CardListCards.css';
import React from 'react';
import { get, injectImageResolution } from '../../../utils';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { Link, Text } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../../atoms/RouterLink';
import ScrollAnimation from 'react-animate-on-scroll';
import { ReactComponent as IconChevronRightLight } from '../../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../../resources/icons/IconChevronLeftLight.svg';
import LazyPicture from '../../atoms/LazyPicture';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../utils/tealium';
import { convertToAnalyticObject } from '../../../utils/analytics';
var Cards = function Cards(_ref) {
  var item = _ref.item,
    params = _ref.params,
    eventsAnalytics = _ref.eventsAnalytics;
  var sitecoreContext = useSitecoreContext();
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var cardImageSrc = get(item, 'image.jss.value.src');
  var cardImageAlt = get(item, 'image.jss.value.alt');
  var hasTitle = get(item, 'title.jss.value');
  var hasDescription = Boolean(get(item, 'description.jss.value'));
  var ctaLabel = get(item, 'ctaLabel.jss.value');
  var ctaLinkHref = get(item, 'ctaLink.jss.value.href');
  var cardTitle = get(item, 'title.jss.value');
  var renderContentInLink = function renderContentInLink(children) {
    if (!ctaLinkHref && !pageEditing) return /*#__PURE__*/React.createElement("div", {
      className: "image-wrapper"
    }, children);
    var linkTitle = '';
    if (hasTitle) {
      linkTitle = hasTitle;
    } else {
      linkTitle = cardImageAlt ? cardImageAlt : '';
    }
    if (ctaLabel) {
      linkTitle = "".concat(ctaLabel, " | ").concat(linkTitle);
    }
    if (item.ctaLink && item.ctaLink.jss && item.ctaLink.jss.value && item.ctaLink.jss.value.target === "_blank") {
      linkTitle = linkTitle ? "".concat(linkTitle) : "";
    }
    return /*#__PURE__*/React.createElement(Link, {
      className: "image-wrapper",
      "aria-label": linkTitle,
      field: item.ctaLink.jss
    }, children);
  };
  var renderLink = function renderLink() {
    if (!ctaLabel || !ctaLinkHref) return null;
    if (pageEditing && ctaLinkHref) {
      return /*#__PURE__*/React.createElement(Link, {
        field: item.ctaLink.jss
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "c--link-more"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: "general-card-button",
      href: item.ctaLink.jss.value.href,
      linktype: "external",
      openInSameTab: true,
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['linkClickAnalytics'], params), [cardTitle, ctaLabel]);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "btn-tertiary__text"
    }, ctaLabel && ctaLinkHref ? ctaLabel : null), ctaLabel && ctaLinkHref ? rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null) : null));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
    className: "card-box theme-contrast"
  }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), cardTitle);
    },
    useEmptyPlaceholder: true,
    hover: true,
    className: "cardListCardsImage"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    src: "".concat(injectImageResolution(cardImageSrc, 1000, 768))
  }), /*#__PURE__*/React.createElement("img", {
    src: "".concat(injectImageResolution(cardImageSrc, 800, 615)),
    alt: cardImageAlt
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: "textContainer"
  }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardTitle",
    field: item.title && item.title.jss,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle);
    }
  }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardDescription",
    field: item.description && item.description.jss
  }) : null, renderLink())));
};
var CardListCards = function CardListCards(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var title = get(fields, 'data.item.title.jss.value');
  var hasDescription = Boolean(get(fields, 'data.item.description.jss.value'));
  var childrenItems = get(fields, 'data.item.children', []);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var items = childrenItems.length ? childrenItems.filter(function (item) {
    return item.title && item.description;
  }) : [];
  var renderItems = function renderItems() {
    return items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        className: "itemWidth",
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 3,
        key: index
      }, /*#__PURE__*/React.createElement(Cards, {
        item: item,
        itemsLength: items.length,
        params: params,
        eventsAnalytics: eventsAnalytics,
        title: title
      }));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, hasTitle || hasDescription ? /*#__PURE__*/React.createElement("div", {
    className: "h__txt"
  }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title componentTitle",
    field: fields.data.item.title.jss
  }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "p componentDescription",
    field: fields.data.item.description.jss
  }) : null) : null, /*#__PURE__*/React.createElement("div", {
    className: "itemsContainer"
  }, renderItems()));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    className = _ref3.className,
    style = _ref3.style;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
export var commonStyles = "ctq9kta";
export var ltrStyles = "l14hw1h6";
export var rtlStyles = "r1pyp86w";
export { CardListCards };